<div class="page-title-area">
    <img src="assets/images/training.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>Training</h2>
            <!-- <p>Superior Digital Private Limited is your trusted Apple Authorised Reseller. Receive expert advice on Apple products and accessories. We offer MDM solutions, Apple Business Manager for Automated Device Enrolment, Zero Touch Deployment, flexible financial options, and ongoing managed services. Enjoy configuration and deployment services for immediate use.</p> -->
        </div>
    </div>

    <!-- <div>
        <img src="assets/images/case-studies.png">
    </div> -->
    <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div>
</div>

<section class="home-case pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span>Training</span>
            <h2>Our Training Programs</h2>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse.</p> -->
        </div>
        <div class="case">
            <!-- <ul class="nav-tabset">
                <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab1'}">
                    <span (click)="switchTab($event, 'tab1')">
                        All
                    </span>
                </li>
                <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab2'}">
                    <span (click)="switchTab($event, 'tab2')">
                        Design
                    </span>
                </li>
                <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab3'}">
                    <span (click)="switchTab($event, 'tab3')">
                        Development
                    </span>
                </li>
                <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab4'}">
                    <span (click)="switchTab($event, 'tab4')">
                        Cyber Security
                    </span>
                </li>
            </ul> -->
            <div class="tabs-container">
                <div class="pane" id="tab1" *ngIf="currentTab === 'tab1'">
                    <div class="row case-list">
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/it-training"><img src="assets/images/solutions-details/45.png" alt="IT Training"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/it-training"><h3>IT Training</h3></a>
                                    <p>Superior Digital empowers your IT support team with expert training on managing, supporting, and troubleshooting Apple devices within your organisation.</p>
                                    <a routerLink="/it-training" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/macOs-basic"><img src="assets/images/solutions-details/43.png" alt="macOS Basic"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/macOs-basic"><h3>macOS - Basic</h3></a>
                                    <p>New to Mac, iPad, or iPhone? Superior Digital offers hands-on guided training to help you get comfortable with your Apple device.</p>
                                    <a routerLink="/macOs-basic" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/macOs-advanced"><img src="assets/images/solutions-details/44.png" alt="macOS Advanced"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/macOs-advanced"><h3>macOS - Advanced</h3></a>
                                    <p>Even experienced Apple users can take their skills to the next level with our specialised training programs.</p>
                                    <a routerLink="/macOs-advanced" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/ios-essential"><img src="assets/images/solutions-details/52.png" alt="iOS Essential"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/ios-essential"><h3>iOS - Essentials</h3></a>
                                    <p>Superior Digital provides customised training for corporates on maximising productivity and creativity with iPads and iPhones.</p>
                                    <a routerLink="/ios-essential" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/ios-technical"><img src="assets/images/solutions-details/47.png" alt="iOS Technical"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/ios-technical"><h3>iOS - Technical</h3></a>
                                    <p>Superior Digital offers specialised training for IT support and help desk teams to efficiently manage iOS devices.</p>
                                    <a routerLink="/ios-technical" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/request-service"><img src="assets/images/solutions-details/8.png" alt="Request Training"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/request-service"><h3>Request Training</h3></a>
                                    <p>Need customised training for your team? Request a training session tailored to your specific needs.</p>
                                    <a routerLink="/request-service" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>